export default class RndtsApiCallbackController {
	static $inject = ['$scope', '$state', '$uibModal', 'registresService', 'notification', '$translate'];

	constructor($scope, $state, $uibModal, registresService, notification, $translate) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.registresService = registresService;
		this.notification = notification;
		this.$translate = $translate;
	}

	async $onInit() {
		this.isApiKeyError = false;
		this.result = this.registresService.getApiResult();
		this.currRes = this.result[0];
		console.log('Resultats API', this.result);
	}

	redirectToDAP(id) {
		let url = this.$state.href('daps.edit', { id: id });
		window.open(url, '_dap');
	}

	redirectToTicket(id) {
		let url = this.$state.href('tickets.detail', { id: id });
		window.open(url, '_tickets');
	}

	isTransporteur(key) {
		let reg = /transporteurs/;
		return reg.test(key);
	}

	getTranspoInfo(key, value) {
		console.log('🔥: RndtsApiCallbackController -> getTranspoInfo -> value', value);
		let d = key.split(']');
		if (!d[1]) return key;
		return this.$translate.instant(`API.transporteurs${d[1]}`);
	}
}
